import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about-page/big-about-img.webp")